import {Pipe, PipeTransform} from '@angular/core';
import {ETipoCuestionario} from '@core/models';

@Pipe({name: 'objetoCustom'})
export class objetoCustomPipe implements PipeTransform {
  transform(value: any): string {
    
    if (typeof value === 'object') {
      // Lógica para formatear el objeto
      if (value.Descripcion) {
        return value.Descripcion;
        
      };
      return JSON.stringify(value); // Ejemplo: Convertir a JSON
    } 
    else if (typeof value === 'boolean') {
      return value ? 'Sí' : 'No';
    }
    else if(value == ''){
      return 'No se registro';
    }
    else {
      return value;
    }
  }
}
